<template>
  <div class="container">
    <div class="page">
      <div class="header_nav">
        <div>合作厂商一</div>
        <div>
          <router-link class="router_link" to="/Home/HL">合作厂商二</router-link>
        </div>
      </div>
      <div class="partner_img">
        <div class="img">
          <img src="../assets/images/jc/1.png">
        </div>
        <div class="img">
          <img src="../assets/images/jc/2.png">
        </div>
        <div class="img">
          <img src="../assets/images/jc/3.png">
        </div>
      </div>
      <div class="section">
        <div>
          <div class="title">简介
            <div></div>
          </div>
          <div class="intro">
            某电装公司是集团汽车线束事业部研发中心和新能源电池包线束生产基地，公司现有员工180人，其中技术研发人员30人，管理人员25人。参与并主导了国内多家汽车公司整车线束设计开发工作，具有完整的3D数模、原理图、产品图纸及线束部品设计能力，具备完全符合IATF16949:2016（含设计研发）体系要求的产品设计和过程管理能力。具备整车高低压线束同步开发能力和年产10万套新能源电池包线束配套能力。
          </div>
        </div>
        <div>
          <div class="title">企业文化
            <div></div>
          </div>
          <div class="culture">
            <ul>
              <li>
                <div class="icon">
                  <span>使</span>
                  <span>命</span>
                </div>
                <ul><li>为客户提供最优线束设计方案</li></ul>
              </li>
              <li>
                <div class="icon">
                  <span>愿</span>
                  <span>景</span>
                </div>
                <ul><li>立足新能源产业，打造一流线束供应商</li></ul>
              </li>
              <li>
                <div class="icon">
                  <span>价</span>
                  <span>值观</span>
                </div>
                <ul><li>诚信 团结 创新 感恩</li></ul>
              </li>
              <li>
                <div class="icon">
                  <span>团</span>
                  <span>队理念</span>
                </div>
                <ul><li>诚信对他人，信心对自己，耐心对事情</li></ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style scoped>
/* 二级导航栏 */
.header_nav>div:first-child {
  background:rgba(0,0,0,1);
  color: #fff;
}
.header_nav>div:nth-child(2):hover {
  color: #a3a3a3;
  cursor: pointer;
}
/* 简介 */
.intro {
  margin-bottom: 60px;
}
/* 企业文化 */
.culture {
  padding: 0
}
.culture ul {
  display: flex;
  justify-content: space-between;
}
.culture ul>li {
  width: 182px;
  height: 190px;
}
.culture ul>li:nth-child(2) {
  width: 238px;
}
.culture ul>li:nth-child(3) {
  width: 126px;
}
.culture ul>li:nth-child(4) {
  width: 238px;
}
.icon {
  width:120px;
  height:120px;
  border:1px solid rgba(216,216,216,1);
  border-radius: 50%;
  margin: 0 auto;
  margin-bottom: 38px;
}
.icon>span {
  font-size: 24px;
  font-weight: 500;
  line-height: 120px;
}
.icon>span:nth-child(2) {
  font-size: 18px;
}
.icon+ul>li {
  width: 100%;
  height: 32px;
  font-size:14px;
  font-weight:400;
  color:rgba(112,112,112,1);
  line-height:32px;
  list-style: disc;
}
</style>